module.exports = __webpack_public_path__ + "img/triplo-diamante.a4dfbe4d.png";